
class ServiceNav {
    constructor () {
        this.menus = [];
        this.indexErro = [];              
    }

    idExists(id) {
        const menu = this.menus;
        let erro = false;

        menu.forEach(element => {
            if(element.id === id) {
                erro = true;
                return;
            }
        });

        return erro;
    }

    addComponent(id, tabName, descricao, validationError, component, props = {}) {
        if(this.idExists(id)) {
            alert('Id informado já existe, verifique');

            return; 
        }

        this.menus.push({
            id: id, 
            tabName: tabName,
            descricao: descricao,
            validationError: validationError,
            component: component,
            props: props
        });        

        this.indexErro.push({
            erro: false
        });
    }        

    setMenu(menus) {
        this.menus = menus;
    }

    getMenu() {
        return this.menus;
    }

    setIndexErro(indice) {
        var index = this.indexErro;
        
        index[indice].erro = true;

        this.indexErro = index;
    }

    clearIndexErro() {
        var index = this.indexErro;        

        for(var i = 0; i < index.length; i++)
            index[i].erro = false;

        this.indexErro = index;
    }

    getIndexErro() {
        return this.indexErro;
    }
}

export default ServiceNav;